import { createContext, useContext, useState,useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../utils/firebase";
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [idToken, setIdToken] = useState(null);
  const [authReady, setAuthReady] = useState(false);
 useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      setUser(firebaseUser);
      try {
        if (firebaseUser) {
          const token = await firebaseUser.getIdToken(); // get ID token
          setIdToken(token);
        } else {
          setIdToken(null);
        }
      } catch (error) {
        console.error("Unable to restore the Firebase session", error);
        setIdToken(null);
      } finally {
        setAuthReady(true);
      }
      setAuthReady(true);
    });

    return () => unsubscribe();
  }, []);
  return (
    <AuthContext.Provider value={{user, idToken, setIdToken, authReady }}>
      {children}
    </AuthContext.Provider>
  );
}
// Custom hook to use AuthContext
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};


